// extracted by mini-css-extract-plugin
export default {"container":"answer_container__3XLSg","wow":"answer_wow__1Kchd","wrongAnswer":"answer_wrongAnswer__1gWh7","rightAnswer":"answer_rightAnswer__6sBc9"};